import React, { useEffect, useRef } from 'react';
import '../../css/home/Logos.css';
import TinderLogo from '../../img/logos/tinderlogo.svg';
import SamsungLogo from '../../img/logos/samsunglogo.png';
import AcornsLogo from '../../img/logos/acornslogo.png';
import AdidasLogo from '../../img/logos/adidaslogo.png';
import BostonGlobeLogo from '../../img/logos/bostonglobelogo.png';
import TiaLupitaLogo from '../../img/logos/tialupitalogo.png';
import FanaticsLogo from '../../img/logos/fanaticslogo.png';

const Logos = () => {
  const logos = [
    SamsungLogo, TinderLogo, AcornsLogo, 
    AdidasLogo, BostonGlobeLogo, TiaLupitaLogo, FanaticsLogo
  ];
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const speed = 50; // pixels per second

  useEffect(() => {
    const container = containerRef.current;
    const logos = container.querySelectorAll('.logo-item');
    
    // Double the logos for seamless looping
    logos.forEach(logo => {
      const clone = logo.cloneNode(true);
      clone.className = 'logo-item cloned';
      container.appendChild(clone);
    });

    let position = 0;
    const animate = () => {
      position -= speed / 60; // Adjust for 60fps
      
      // Reset position when half way
      if (position <= -container.scrollWidth / 2) {
        position = 0;
      }
      
      container.style.transform = `translateX(${position}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, []);

  return (
    <section className="logo-section">
      <h2 className="logo-title">Trusted by brands shaping the future.</h2>
      <div className="logo-wrapper">
        <div className="logo-container" ref={containerRef}>
          {logos.map((logo, index) => (
            <img 
              key={index}
              src={logo}
              alt={`Logo ${index}`}
              className="logo-item"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;